import { RegisterActividadProgramaForm } from "@/components/forms/actividades-programas/RegisterActividadProgramaForm";
import { Button } from "@/shared/components/ui/button";
import DataTable from "@/components/ui/dataTable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/Skeleton";
import { useActividadesPrograma } from "@/hooks/actividadesProgramas/useActividadesProgramas";
import type { ActividadPrograma } from "@/interfaces/actividadPrograma.interface";
import { columns } from "@/lib/columns/actividadesPrograma.columns";
import { useState } from "react";

export interface ActividadesProgramasResponse {
  data: ActividadPrograma[];
  total: number;
}

export default function ActividadesProgramas() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const { data, isLoading, isFetching, refetch } = useActividadesPrograma(
    page,
    limit,
    search,
  );

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-6 w-80" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  const createActividadesProgramaModal = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Registrar Actividad
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl xl:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Registrar Actividad</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Llena el siguiente formulario para registrar una nueva actividad.
        </DialogDescription>
        <div className="py-4">
          <RegisterActividadProgramaForm setOpen={setOpen} refetch={refetch} />
        </div>
      </DialogContent>
    </Dialog>
  );

  return (
    <section className="w-full p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6">
      <div>
        <DataTable<ActividadPrograma>
          columns={columns}
          data={data?.data ?? []}
          total={data?.total ?? 0}
          page={page}
          limit={limit}
          onPageChange={setPage}
          isLoading={isFetching}
          search={search}
          onSearchChange={(value) => {
            setPage(1);
            setSearch(value);
          }}
          headerActions={createActividadesProgramaModal}
        />
      </div>
    </section>
  );
}
